module.exports = __webpack_public_path__ + "media/svg/arrow-right-2bd46576.svg";